import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';
import { BlendFunction } from 'postprocessing';

export interface DepthEffectProperties extends EffectProperties {
  inverted: boolean;
}

// Create a reusable Depth component that can be used in both preview and world
const DepthComponent = forwardRef<any, { properties: DepthEffectProperties; isPreview?: boolean }>((props, ref) => {
  
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { inverted, blendFunction } = properties;

  // Convert blendFunction string to number if it exists
  const blendFunctionValue = blendFunction ? 
    BlendFunction[blendFunction as keyof typeof BlendFunction] : 
    BlendFunction.NORMAL;

  return (
    <PostProcessing.Depth
      inverted={inverted}
      blendFunction={blendFunctionValue}
    />
  );
});

export const DepthEffectItem: Effect<DepthEffectProperties> = {
  id: '',
  name: 'Depth',
  type: 'effect',
  subtype: 'Depth',
  icon: 'Effect',
  properties: {
    inverted: false,
    blendFunction: 'NORMAL',
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.inverted',
      type: 'boolean',
      label: 'Inverted',
      default: false,
      panel: 'effect',
    },
    {
      key: 'properties.blendFunction',
      type: 'select',
      label: 'Blend Function',
      default: 'NORMAL',
      options: [
        { value: 'NORMAL', label: 'Normal' },
        { value: 'ADD', label: 'Add' },
        { value: 'SUBTRACT', label: 'Subtract' },
        { value: 'MULTIPLY', label: 'Multiply' },
        { value: 'SCREEN', label: 'Screen' },
        { value: 'OVERLAY', label: 'Overlay' },
      ],
      panel: 'effect',
    }
  ],
  render: (properties: DepthEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <DepthComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
}; 